module.exports = __webpack_public_path__ + "static/media/SepafinLogo.af98c8c1.svg";